/**
 * CommunityRatingSection — overall ScribbleReads rating + star-by-star
 * distribution. Bars reuse the same gradient look as ReadingProgress
 * (site/primitives.jsx) rather than a plain flat bar, to stay visually
 * consistent with the rest of the app.
 */

import React from 'react';
import { Stars } from '@/components/site/primitives';

export default function CommunityRatingSection({ ratingSummary }) {
  if (!ratingSummary) return null;
  const { average, count, distribution } = ratingSummary;
  const maxCount = Math.max(1, ...distribution.map((d) => d.count));

  return (
    <section className="u-container mt-10 md:mt-14" data-testid="book-details-rating">
      <div className="card-paper p-5 sm:p-6">
        <h2 className="font-display text-lg font-semibold text-ink">Community Rating</h2>

        <div className="mt-4 flex flex-col gap-6 sm:flex-row sm:items-center">
          <div className="shrink-0 text-center sm:text-left">
            <p className="font-display text-4xl font-semibold text-ink">{average.toFixed(2)}</p>
            <Stars value={Math.round(average)} size={16} />
            <p className="mt-1 text-xs text-subtle">{count.toLocaleString()} ratings</p>
          </div>

          <div className="flex-1 space-y-1.5">
            {distribution.map(({ star, count: starCount }) => (
              <div key={star} className="flex items-center gap-2.5 text-xs text-subtle">
                <span className="w-2.5 shrink-0 font-medium">{star}</span>
                <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-line/60">
                  <div
                    className="h-full rounded-full bg-gradient-to-r from-coral to-yellow"
                    style={{ width: `${(starCount / maxCount) * 100}%` }}
                  />
                </div>
                <span className="w-10 shrink-0 text-right">{starCount.toLocaleString()}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
